export class UpdateGroupRequest {
   isActive: boolean = true;
}
